// © 2026 Holmes Computer Consultants. All rights reserved. -- www.holmesconsultants.com
import {BufferAttribute,BufferGeometry} from 'three'
import {flasherMountFits,flasherFloorHeightScale} from './flasherMount'
import type {MachineDefinition,MachineLamp} from '@core/machine'
import type source from '../../SourceArt/FlasherAssembly/mesh.json'
let data:typeof source|undefined
export async function prepareFlasherAssembly():Promise<void>{data??=(await import('../../SourceArt/FlasherAssembly/mesh.json')).default}
export const FLASHER_POOL_RADIUS=.125,FLASHER_EMITTER_HEIGHT=.066,FLASHER_POOL_SIZE=32,FLASHER_MOUNT_HEIGHT=.034
export function flasherPart(role:string,reach=.045):BufferGeometry|undefined{
 const part=data?.parts.find(p=>p.role===role);if(!part)return undefined
 const g=new BufferGeometry();g.setAttribute('position',new BufferAttribute(new Float32Array(part.positions),3));g.setAttribute('normal',new BufferAttribute(new Float32Array(part.normals),3));g.setAttribute('uv',new BufferAttribute(new Float32Array(part.uvs),2));g.setIndex(part.triangles)
 if(role==='bracket'&&reach!==.045){const p=g.getAttribute('position');for(let i=0;i<p.count;i++)if(p.getY(i)>=.028-1e-8)p.setY(i,p.getY(i)+reach-.045);g.computeVertexNormals()}
 g.computeBoundingBox();g.computeBoundingSphere();return g
}
export {flasherMountFits,flasherFloorHeightScale} from './flasherMount'
/** Static low-resolution falloff, clipped to real board bounds and the upper wall's shadow.
 * This is a bounded approximation of one raised source, not scene-wide dynamic shadows. */
export function flasherPoolPixels(d:MachineDefinition,lamp:MachineLamp):Uint8Array{
 const bytes=new Uint8Array(FLASHER_POOL_SIZE*FLASHER_POOL_SIZE*4),p=lamp.position!,wall=d.colliders.find(c=>c.id==='wallTop'),board=d.dimensions.playfield,emitter=flasherMountFits(d,lamp)?FLASHER_EMITTER_HEIGHT:.032*flasherFloorHeightScale(lamp.radius??.026)
 for(let y=0;y<FLASHER_POOL_SIZE;y++)for(let x=0;x<FLASHER_POOL_SIZE;x++){
  const u=(x+.5)/FLASHER_POOL_SIZE,v=(y+.5)/FLASHER_POOL_SIZE,dx=(u-.5)*2*FLASHER_POOL_RADIUS,dy=(v-.5)*2*FLASHER_POOL_RADIUS
  const px=p[0]+dx,py=p[1]+dy;let visibility=1
  if(Math.abs(px)>board.width/2||Math.abs(py)>board.length/2)visibility=0
  if(wall?.kind==='segment'&&Math.abs(wall.a[1]-wall.b[1])<1e-9&&Math.abs(dy)>1e-9){
   const t=(wall.a[1]-p[1])/dy,atX=p[0]+dx*t
   if(t>0&&t<1&&atX>=Math.min(wall.a[0],wall.b[0])&&atX<=Math.max(wall.a[0],wall.b[0])){
    const height=emitter*(1-t),a=Math.max(0,Math.min(1,(height-.029)/.006));visibility*=a*a*(3-2*a)
   }
  }
  const distance=Math.hypot(dx,dy),self=Math.max(0,Math.min(1,(distance-.030)/.030));visibility*=self*self*(3-2*self)
  const value=Math.round(255*Math.max(0,1-distance/FLASHER_POOL_RADIUS)**2*visibility),at=(y*FLASHER_POOL_SIZE+x)*4
  bytes[at]=bytes[at+1]=bytes[at+2]=value;bytes[at+3]=255
 }
 return bytes
}
